/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioValueChangedNotificationPayloadDto
 */
export interface PortfolioValueChangedNotificationPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    previousValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    currentValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    absoluteChange: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    percentageChange: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    previousDate: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationPayloadDto
     */
    currentDate: string;
}

export function PortfolioValueChangedNotificationPayloadDtoFromJSON(json: any): PortfolioValueChangedNotificationPayloadDto {
    return PortfolioValueChangedNotificationPayloadDtoFromJSONTyped(json, false);
}

export function PortfolioValueChangedNotificationPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioValueChangedNotificationPayloadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'previousValue': json['previousValue'],
        'currentValue': json['currentValue'],
        'absoluteChange': json['absoluteChange'],
        'percentageChange': json['percentageChange'],
        'previousDate': json['previousDate'],
        'currentDate': json['currentDate'],
    };
}

export function PortfolioValueChangedNotificationPayloadDtoToJSON(value?: PortfolioValueChangedNotificationPayloadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currencyCode': value.currencyCode,
        'previousValue': value.previousValue,
        'currentValue': value.currentValue,
        'absoluteChange': value.absoluteChange,
        'percentageChange': value.percentageChange,
        'previousDate': value.previousDate,
        'currentDate': value.currentDate,
    };
}

